import React from "react";
import { Link, useParams } from "react-router-dom";
import "../styles/Notice.css"; // Import du fichier CSS

const products = [
  { name: "B01", id: "b01" },
  // { name: "B01 Lite", id: "b01-lite" },
  { name: "H01", id: "h01" },
  // { name: "Smartfix", id: "smartfix" }
];

const languages = [
  { code: "FR", name: "Français" },
  // { code: "EN", name: "English" },
  // { code: "NL", name: "Nederlands" },
  // { code: "DE", name: "Deutsch" },
  // { code: "ES", name: "Español" },
  // { code: "IT", name: "Italiano" }
];

export const Notice = () => (
  <div className="Notice_container" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
    <h1 className="Notice_h1">Trouvez la notice de votre produit</h1>
    <p className="Notice_text">
      Bienvenue sur notre espace dédié aux notices d'utilisation.  
      Sélectionnez le modèle de votre produit ci-dessous pour accéder aux instructions détaillées et optimiser son utilisation.
    </p>
    <div className="Notice_grid">
      {products.map((product) => (
        <Link key={product.id} to={`/qr/notices-utilisation/${product.id}`} className="Notice_button">
          {product.name}
        </Link>
      ))}
    </div>
    <p className="Notice_info">
      Si vous ne trouvez pas votre produit ou si vous avez des questions, n'hésitez pas à nous contacter.
    </p>
  </div>
);

export const LanguageSelection = () => {
  const { productId } = useParams();

  return (
    <div className="Notice_container" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
      <h1 className="Notice_h1">Choisissez votre langue</h1>
      <p className="Notice_text">
        Sélectionnez la langue dans laquelle vous souhaitez consulter la notice du produit.  
        Cliquez sur votre choix et le document s’ouvrira dans un nouvel onglet.
      </p>
      <div className="Notice_grid">
        {languages.map((lang) => (
          <a
            key={lang.code}
            href={`https://prod-baltee-hosting-public.s3.eu-west-1.amazonaws.com/notices/${productId}/${lang.code}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="Notice_button"
          >
            {lang.name}
          </a>
        ))}
      </div>
      <p className="Notice_info">
        Vous ne trouvez pas la notice dans votre langue ? Contactez notre support pour obtenir une aide personnalisée.
      </p>
      <Link to="/qr/notices-utilisation" className="Notice_back-link">← Retour à la sélection des produits</Link>
    </div>
  );
};
